<template>
<div class="chapter">
<div class="inner_page">
<h2 class="part-no">PART I</h2>
<h2 class="part-title">SEEKING HAPPINESS IN PLEASURE (HEDONIC) DIMENSION</h2>
<p class="p-image"><img alt="image" src="images/p19.png"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?6aa5424e